import type { NotificationDtoEventTypeEnumKey } from "@synthesis/shared-services/notification/external/types";

import type { ApplicationNotification, NotificationAction, NotificationAdapter } from "../notifications-panel.types";

const EVENT_BODIES: Record<NotificationDtoEventTypeEnumKey, (number: string) => string> = {
  APPLICATION_SUBMITTED: (number) => `Заявка${number} подана.`,
  APPROVERS_ASSIGNED: (number) => `По заявке${number} назначены согласующие.`,
  APPROVER_REVIEWED: (number) => `Согласующий рассмотрел заявку${number}.`,
  FINAL_DECISION: (number) => `По заявке${number} принято итоговое решение.`,
  EMAIL_CHANGE_OLD_EMAIL_NOTICE: () => "Предпринята попытка изменения адреса электронной почты для входа в учётную запись.",
  EMAIL_CHANGE_CONFIRMATION: () => "Для подтверждения нового адреса электронной почты перейдите по ссылке в письме.",
  EMAIL_CHANGED: () => "Адрес электронной почты учётной записи изменён.",
};

export const createEventNotificationAdapter = (notification: ApplicationNotification): NotificationAdapter | null => {
  if (!Object.hasOwn(EVENT_BODIES, notification.name)) {
    return null;
  }

  const event = notification.name as NotificationDtoEventTypeEnumKey;
  const number = notification.params.applicationNumber?.trim();
  const body = EVENT_BODIES[event](number ? ` №${number}` : "");
  const isApplicationEvent = !event.startsWith("EMAIL_");
  const actions: NotificationAction[] =
    notification.requestId && isApplicationEvent
      ? [
          {
            title: event === "FINAL_DECISION" ? "Перейти к решению" : "Перейти к заявке",
            type: "link",
            payload: `/applications/${notification.requestId}`,
            target: { requestId: notification.requestId, tab: event === "FINAL_DECISION" ? "final-decision" : undefined },
          },
        ]
      : [];

  return {
    getTitle: () => notification.title ?? "Уведомление",
    getBody: () => ({ body }),
    getActions: () => actions,
  };
};
